import { render } from "./LoginView.vue?vue&type=template&id=4ff580f4"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\chany\\Desktop\\my\\apache\\project\\vue_wage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__